import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {NgbModule, NgbToastModule} from '@ng-bootstrap/ng-bootstrap';
import {MenuComponent} from './UI/menu/menu.component';
import {FooterComponent} from './UI/footer/footer.component';
import {LayoutComponent} from './UI/layout/layout.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {JwtInterceptor, ErrorInterceptor} from './core/_helpers';
import {SharedModule} from './shared/shared.module';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {FaqsComponent} from './pages/faqs/faqs.component';
import {AboutUsComponent} from './pages/about-us/about-us.component';
import {DataProtectionComponent} from './pages/data-protection/data-protection.component';
import {MentionLegalesComponent} from './pages/mention-legales/mention-legales.component';
import {MondatsComponent} from './pages/mondats/mondats.component';
import {SignInComponent} from './modules/auth/sign-in/sign-in.component';
import {SignUpComponent} from './modules/auth/sign-up/sign-up.component';
import {ConcessionaireComponent} from './pages/concessionaire/concessionaire.component';
import {SignOutComponent} from './modules/auth/sign-out/sign-out.component';
import {AuthService} from './core/auth/auth.service';
import {ResetPasswordComponent} from './modules/auth/reset-password/reset-password.component';
import {SsoInterceptor} from './core/_helpers/sso.interceptor';
import {NgbdToastGlobal} from './shared/components/toast/toast-global.component';
import {VerificationPasswordComponent} from './modules/auth/verification-password/verification-password.component';
import {SitemapComponent} from './pages/sitemap/sitemap.component';
import {TarifsDepartementsComponent} from './pages/tarifs-departements/tarifs-departements.component';
import {FeesAmisComponent} from "./modules/amis/components/fees-amis/fees-amis.component";
import {Erreur404Component} from "./pages/erreur404/erreur404.component";
import {DesabonnementComponent} from './pages/desabonnement/desabonnement.component';
import {SatisfactionComponent} from './pages/satisfaction/satisfaction.component';
import { AgenceByTdmComponent } from './pages/agence-by-tdm/agence-by-tdm.component';
import { ByTdmComponent } from './pages/by-tdm/by-tdm.component';
import { ContactByTdmComponent } from './pages/contact-by-tdm/contact-by-tdm.component';

@NgModule({ declarations: [
        MenuComponent,
        FooterComponent,
        LayoutComponent,
        FaqsComponent,
        AboutUsComponent,
        DataProtectionComponent,
        MentionLegalesComponent,
        MondatsComponent,
        ConcessionaireComponent,
        SignInComponent,
        SignUpComponent,
        SignOutComponent,
        ResetPasswordComponent,
        VerificationPasswordComponent,
        SitemapComponent,
        TarifsDepartementsComponent,
        Erreur404Component,
        DesabonnementComponent,
        SatisfactionComponent,
        AgenceByTdmComponent,
        ByTdmComponent,
        ContactByTdmComponent
    ],
    bootstrap: [LayoutComponent], imports: [BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        AppRoutingModule,
        NgbModule,
        SharedModule,
        FontAwesomeModule,
        NgbdToastGlobal,
        FeesAmisComponent], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SsoInterceptor, multi: true },
        AuthService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
  }
}
